module.exports = __webpack_public_path__ + "RMR - Account Upgrade Template.pdf";